import "./main.css";
import Profile from "./profile-block/Profile";
import About from "./about-block/About";
import Experience from "./experience-block/Experience";
import Portfolio from "./portfolio-block/Portfolio"

const Main = () => (
  <main>
      <Profile />
      <About />
      <Experience />
      <Portfolio />
  </main>
);

export default Main;
